import { type OperationContext, type OperationResult, useMutation } from "urql"

import type {
  Mutation,
  RoleMutationCreateArgs,
  RoleMutationDeleteArgs,
  RoleMutationUpdateArgs,
} from "@/graphql/codegen/graphql"
import {
  CreateRoleMutationDocument,
  DeleteRoleMutationDocument,
  UpdateRoleMutationDocument,
} from "@/graphql/codegen/graphql"

interface UseRoleReturn {
  createRole: (
    variables: RoleMutationCreateArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "role">, RoleMutationCreateArgs>>

  updateRole: (
    variables: RoleMutationUpdateArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "role">, RoleMutationUpdateArgs>>

  deleteRole: (
    variables: RoleMutationDeleteArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "role">, RoleMutationDeleteArgs>>
}

export const useRole = (): UseRoleReturn => {
  const [, createRole] = useMutation<Pick<Mutation, "role">, RoleMutationCreateArgs>(CreateRoleMutationDocument)
  const [, updateRole] = useMutation<Pick<Mutation, "role">, RoleMutationUpdateArgs>(UpdateRoleMutationDocument)
  const [, deleteRole] = useMutation<Pick<Mutation, "role">, RoleMutationDeleteArgs>(DeleteRoleMutationDocument)

  return {
    createRole,
    updateRole,
    deleteRole,
  }
}
